// This file is auto-generated by @hey-api/openapi-ts
import { client } from "./client.gen.js";
/**
 * Estado del servicio
 *
 * Verifica el estado del servicio de Sunner Cloud.
 */
export const getHealth = (options) => (options?.client ?? client).get({
    url: "/health",
    ...options,
});
/**
 * Obtener feature flags de frontend
 *
 * Devuelve todas las feature flags disponibles de frontend
 */
export const getFeatureFlags = (options) => (options?.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/feature-flags",
    ...options,
});
/**
 * Iniciar sesión de usuario
 *
 * Autentica a un usuario mediante email y contraseña y devuelve un token de acceso.
 */
export const login = (options) => (options.client ?? client).post({
    url: "/auth/login",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * Obtener información del usuario autenticado
 *
 * Devuelve la información del usuario autenticado incluyendo sus permisos.
 */
export const getMe = (options) => (options?.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/auth/me",
    ...options,
});
/**
 * Compañías
 *
 * Devuelve las compañías que pueden ser dueñas de una planta, para que el
 * formulario de alta las ofrezca. Solo responde a usuarios del operador: es
 * la única compañía que puede crear plantas para terceros, y la lista incluye
 * los nombres del resto de clientes.
 *
 */
export const getCompanies = (options) => (options?.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/companies",
    ...options,
});
/**
 * Plantas
 *
 * Obtención de un listado de plantas.
 */
export const getPlants = (options) => (options?.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants",
    ...options,
});
/**
 * Crear una planta
 *
 * Crea una planta a partir de sus datos de identidad. El resto lo resuelve el
 * servidor: la compañía dueña (la del creador, salvo que el operador indique
 * otra), el broker MQTT (el marcado por defecto en la compañía dueña), el
 * namespace MQTT (alfanumérico de 8, único por broker) y la zona horaria
 * (derivada de la latitud y la longitud).
 *
 * La planta nace en estado `construction` y sin dispositivos, así que aparece
 * como sin configurar en el listado. No se guardan credenciales MQTT: la
 * conexión es anónima.
 *
 * Toda la compañía dueña ve la planta desde el primer momento, sin
 * asignaciones por usuario.
 *
 * Exige el permiso `plant:create` y la feature flag `enable_plant_creation`
 * activa.
 *
 */
export const createPlant = (options) => (options.client ?? client).post({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * KPIs de la flota
 *
 * Devuelve los KPIs agregados de la flota del usuario autenticado.
 */
export const getPlantsKpis = (options) => (options?.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/kpis",
    ...options,
});
/**
 * Stream de estado de todas las plantas
 *
 * Devuelve un flujo en tiempo real con el estado completo de todas las plantas  del sistema, incluyendo alarmas, disponibilidad y métricas de estado.
 */
export const getPlantsStatusDataStream = (options) => (options?.client ?? client).sse.get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/status",
    ...options,
});
/**
 * Obtener la disponibilidad reciente de las plantas accesibles
 *
 * Devuelve la disponibilidad reciente de todas las plantas accesibles por el usuario autenticado. Las plantas sin registros se omiten silenciosamente.
 */
export const getPlantsAvailability = (options) => (options?.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/availability",
    ...options,
});
/**
 * Obtener una planta específica
 *
 * Obtiene los detalles de una planta específica por su ID.
 */
export const getPlantById = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}",
    ...options,
});
/**
 * Actualizar los datos generales de una planta
 *
 * Corrige los datos generales de una planta: nombre, localidad, país,
 * coordenadas y tamaño. Solo cambian los campos enviados, con las mismas
 * reglas que el alta. Al cambiar la localidad o el país se recompone
 * `location`, y al cambiar las coordenadas, la zona horaria.
 *
 * La compañía dueña no se edita desde aquí: cambiarla es una transferencia
 * (ADR 0012).
 *
 * Solo pueden escribir la compañía dueña y el operador. Una compañía con
 * concesión de solo lectura recibe 404, igual que en el borrador de
 * configuración.
 *
 */
export const updatePlant = (options) => (options.client ?? client).patch({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * Listar NCUs de una planta
 *
 * Obtiene el listado de NCUs asociadas a una planta.
 */
export const getPlantNcus = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus",
    ...options,
});
/**
 * Listar TCUs de una planta
 *
 * Obtiene el listado de TCUs asociadas a una planta.
 */
export const getPlantTcus = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/tcus",
    ...options,
});
/**
 * Listar HSUs de una planta
 *
 * Obtiene el listado de HSUs asociadas a una planta.
 */
export const getPlantHsus = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/hsus",
    ...options,
});
/**
 * Listar el layout declarado de una planta
 *
 * Obtiene los trackers del inventario declarado de una planta, con su posición
 * para pintar el layout.
 *
 */
export const getPlantTrackers = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/trackers",
    ...options,
});
/**
 * Consultar la configuración vigente de una planta
 *
 * Devuelve la configuración vigente de la planta —sus TCU y sus HSU con
 * nombre, slave, PAN ID y coordenadas, sus valores de planta de TCU y HSU y
 * su backtracking— junto con el número de versión, el usuario que la fijó y
 * cuándo. `backtracking` llega a null cuando la versión no lo declara, y los
 * valores de planta que la versión no declara, también.
 *
 * Incluye los dispositivos descubiertos, los que entraron por haberse
 * comisionado sin estar declarados: forman parte de la configuración vigente
 * igual que los declarados.
 *
 * Cada lista viene ordenada por red y, dentro de cada red, por slave, para
 * que la misma configuración se lea siempre igual. Ordenar por nombre no
 * sirve: en campo los dispositivos se llaman con números sin rellenar, y un
 * orden de texto los deja como `1, 10, 11, 2, 20`.
 *
 * Solo devuelve la vigente. El borrador de la planta no se consulta por aquí:
 * es un estado intermedio del wizard y no tiene versión ni autor.
 *
 * Responde 404 siempre que no haya configuración que devolver, sin distinguir
 * el motivo: la planta no existe, no es de tu cuenta, o existe y todavía no
 * tiene ninguna versión publicada. Mientras el layout siga alimentándose de
 * las tablas declaradas, una planta configurada por la vía del fichero de
 * campo responde 404 aunque su layout se pinte.
 *
 */
export const getPlantConfiguration = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/configuration",
    ...options,
});
/**
 * Fijar la configuración de una planta
 *
 * Fija la configuración recibida como la vigente de la planta: le asigna
 * número de versión, deja la anterior como histórico (`superseded`) y
 * registra quién la fijó y cuándo. Consume el borrador de la planta, si lo
 * había.
 *
 * A diferencia del borrador, no admite campos a medias: el schema exige
 * nombre, PAN ID y coordenadas en todos los dispositivos, e identifica en el
 * 400 cuál de ellos falla.
 *
 * El slave no se recibe: lo asigna Sunner Cloud, en el rango de su tipo —TCU
 * `[1, 229]`, HSU `[230, 245]`— y sin repetirlo dentro de un mismo PAN ID de
 * la planta. Un dispositivo que ya tenía slave en la versión anterior lo
 * conserva: es su dirección real en la red, y reasignarlo lo descolgaría del
 * comisionado y de la telemetría.
 *
 * Los dispositivos descubiertos de la versión anterior —los que entraron por
 * haberse comisionado, no por declararlos— se conservan en la nueva aunque no
 * vengan en el cuerpo: publicar no borra del layout un dispositivo que está
 * físicamente puesto.
 *
 * El backtracking no se recibe aquí: la versión nueva copia el del borrador.
 * Sin borrador, o con un borrador que no lo declara, conserva el de la
 * versión anterior.
 *
 * `zigbee_encryption` tampoco se recibe aquí: la versión nueva copia el del
 * borrador.
 *
 * Los valores de planta de TCU y HSU (`tcu_defaults`, `hsu_defaults`) tampoco:
 * la versión nueva copia los del borrador, y sin borrador conserva los de la
 * versión anterior. Rechaza publicar (400) si alguna alarma de viento tiene la
 * velocidad de desactivación por encima de la de activación.
 *
 * Cada NCU declara el PAN ID de su gateway 1 y, si lo tiene, del gateway 2.
 * Rechaza publicar si algún PAN ID de un TCU o una HSU no lo atiende ninguna
 * NCU: una red huérfana deja de ser posible en el dato.
 *
 */
export const publishPlantConfiguration = (options) => (options.client ?? client).post({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/configuration",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * Leer el borrador de configuración de una planta
 *
 * Devuelve el borrador tal cual se guardó, con los campos a medias que
 * tuviera: la forma de escritura sirve de lectura. No valida que la
 * configuración esté completa.
 *
 * 404 cuando la planta no tiene borrador. No es un error: es que el wizard
 * se abre vacío.
 *
 * El slave no viaja aquí: se asigna al publicar la versión.
 *
 * El backtracking vuelve con los campos que se guardaron y el resto a null.
 * Si el borrador no lo declara, `backtracking` llega a null. Igual con los
 * valores de planta de `tcu_defaults` y `hsu_defaults`: los no guardados
 * llegan a null.
 *
 */
export const getPlantConfigurationDraft = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/configuration/draft",
    ...options,
});
/**
 * Guardar el borrador de configuración de una planta
 *
 * Guarda lo que el wizard lleva escrito. Reemplaza el borrador anterior de la
 * planta en lugar de acumular un segundo, y no toca la configuración vigente:
 * hasta que se publica, el borrador no se ve en el layout ni en ningún
 * contador.
 *
 * Admite campos a medias —el usuario todavía está escribiendo—, así que no
 * valida que la configuración esté completa. Sí rechaza un PAN ID mal formado,
 * un valor del backtracking o de los valores de planta fuera de rango, una
 * alarma de viento con la velocidad de desactivación por encima de la de
 * activación o una posición de una TCU que sus límites mecánicos no alcanzan
 * (400), y dos dispositivos con el mismo nombre (409). Una TCU sin límites
 * mecánicos o sin una posición se valida con el valor por defecto.
 *
 * El backtracking y los valores de planta de TCU y HSU viajan aquí, no en el
 * cuerpo de publicar: al publicar, la versión nueva los copia del borrador.
 *
 * El slave no se recibe: se asigna al publicar la versión. En el borrador
 * queda sin asignar.
 *
 */
export const savePlantConfigurationDraft = (options) => (options.client ?? client).put({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/configuration/draft",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * Consultar los valores por defecto de la plantilla de configuración
 *
 * Devuelve los valores por defecto de la plantilla de configuración: los que
 * el wizard muestra en un campo que el usuario no ha tocado y los que rellena
 * al publicar.
 *
 * No dependen de la planta. Cuelgan de ella para pasar por el mismo control
 * de acceso que el resto de su configuración.
 *
 * No se declaran con `default:` en los esquemas de escritura: Fastify los
 * aplicaría al validar, y el borrador guardaría como declarados valores que
 * el usuario no ha tocado.
 *
 */
export const getPlantConfigurationDefaults = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/configuration/defaults",
    ...options,
});
/**
 * Listar las configuraciones de una planta
 *
 * Devuelve de un vistazo qué configuraciones tiene la planta: la vigente, el
 * borrador si lo hay y el historial de versiones superadas, de más reciente a
 * más antigua. Solo metadatos: qué versión es, quién la fijó y cuándo. Los
 * dispositivos de cada versión se piden con
 * `GET /plants/{plant_id}/configurations/{version}`.
 *
 * Los tres campos vienen siempre. `current` y `draft` son `null` cuando la
 * planta no tiene vigente o borrador, y `superseded` es una lista vacía si
 * nunca ha reemplazado una versión. Una planta recién creada responde 200 con
 * todo vacío: no tener configuración no es un error.
 *
 * El borrador no tiene versión ni autor: solo la fecha del último guardado.
 *
 * Responde 404 solo cuando la planta no existe o no es de tu cuenta, sin
 * distinguir el motivo.
 *
 */
export const listPlantConfigurations = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/configurations",
    ...options,
});
/**
 * Consultar una versión publicada de la configuración de una planta
 *
 * Devuelve una versión publicada de la configuración de la planta, sea la
 * vigente o una ya superada, con la misma forma que
 * `GET /plants/{plant_id}/configuration`: sus TCU, sus HSU y sus NCU junto
 * con el número de versión, el usuario que la fijó y cuándo.
 *
 * Una versión superada se devuelve tal y como quedó al reemplazarse. La
 * respuesta no dice si es la vigente: eso lo cuenta el listado de
 * `GET /plants/{plant_id}/configurations`.
 *
 * El borrador no se consulta por aquí: no tiene versión.
 *
 * Responde 404 siempre que no haya versión que devolver, sin distinguir el
 * motivo: la planta no existe, no es de tu cuenta, o no tiene esa versión.
 *
 */
export const getPlantConfigurationVersion = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/configurations/{version}",
    ...options,
});
/**
 * Descargar las user keys de las NCU de una versión publicada
 *
 * Devuelve el fichero de texto plano con las user keys del cifrado Zigbee
 * que el instalador carga en las NCU de una versión publicada de la
 * configuración de la planta. Es texto para leerlo, no un CSV: Excel convierte
 * en número los valores hex que lo parecen.
 *
 * La primera línea es `User keys Zigbee — {nombre de la planta}`. Debajo, un
 * bloque por NCU separado por una línea en blanco: el nombre de la NCU y una
 * línea por gateway que tenga PAN, con dos espacios de sangría y tres entre
 * campos: `Gateway {1|2}   PAN {pan_id}   User key {user_key}`. El PAN ID va en
 * 16 hex en minúsculas y la user key en hex en mayúsculas. UTF-8 con saltos de
 * línea `\r\n`.
 *
 * La user key es de la planta y el PAN, no de la versión: dos versiones que
 * usan el mismo PAN dan la misma. La longitud no es fija: hoy son 8
 * caracteres hexadecimales y pasarán a 32.
 *
 * Exige permiso de escritura sobre la planta: una concesión, que solo da
 * lectura, no basta. Responde 404 sin distinguir el motivo: la planta no
 * existe, no es de tu cuenta, no puedes escribir en ella o no tiene esa
 * versión. La descarga se puede repetir.
 *
 */
export const getPlantConfigurationUserKeys = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/configurations/{version}/user-keys",
    ...options,
});
/**
 * Iniciar sesión en el canal de la app
 *
 * Autentica una cuenta de empresa cliente en el canal de la app y devuelve
 * la sesión (access + refresh) junto con la marca de la cuenta. Distinto del
 * login web: solo acepta cuentas con permiso de ingesta.
 *
 */
export const appIngestionLogin = (options) => (options.client ?? client).post({
    url: "/app-ingestion/auth/login",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * Renovar la sesión del canal de la app
 *
 * Rota el refresh token (invalida el anterior) y devuelve un par nuevo de
 * tokens con caducidad deslizante. No requiere volver a introducir
 * credenciales.
 *
 */
export const appIngestionRefresh = (options) => (options.client ?? client).post({
    url: "/app-ingestion/auth/refresh",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * Listar las plantas de la cuenta (app de campo)
 *
 * Devuelve las plantas asignadas a la empresa de la cuenta, con su estado,
 * para elegir planta al iniciar la puesta en marcha. Solo las suyas.
 *
 */
export const listAppIngestionPlants = (options) => (options?.client ?? client).get({
    security: [
        {
            key: "appIngestionAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/app-ingestion/plants",
    ...options,
});
/**
 * Descargar la configuración de una planta (app de campo)
 *
 * Devuelve, en una sola respuesta, la configuración vigente de la planta
 * pedida y el número de la versión publicada. Cada TCU y cada HSU viaja con
 * todas las columnas de su plantilla de referencia (versión 1.5): el dato de
 * Cloud donde lo hay y el valor por defecto en el resto. Es la misma tabla
 * de la que salen los CSV que exporta la web.
 *
 * Incluye los dispositivos descubiertos, los que entraron por haberse
 * comisionado sin estar declarados: forman parte de la configuración
 * vigente igual que los declarados. El borrador no se descarga nunca.
 *
 * Lleva también si la red Zigbee de la planta va cifrada
 * (zigbee_encryption) y la user key de cada PAN (user_keys). La app busca
 * la user key de cada dispositivo por el panId de su fila. Con
 * zigbee_encryption false, user_keys es {} aunque la planta tenga user keys
 * guardadas de una versión anterior.
 *
 * Distingue la planta sin configuración de la que no se puede descargar:
 * 204 si la planta es de la cuenta pero todavía no tiene ninguna versión
 * publicada, y 404 si no existe o no es de la cuenta del token.
 *
 */
export const getAppIngestionPlantConfiguration = (options) => (options.client ?? client).get({
    security: [
        {
            key: "appIngestionAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/app-ingestion/plants/{plant_id}/configuration",
    ...options,
});
/**
 * Registrar el comisionado de un dispositivo en campo (app de campo)
 *
 * La app envía este evento tras comisionar un dispositivo por Bluetooth. El
 * endpoint no está scopeado a una planta: la planta se determina a partir de
 * la coordenada del dispositivo, así que la petición no lleva `plant_id`. Si
 * la coordenada no resuelve ninguna planta, el evento se guarda sin ella,
 * atribuido a la cuenta. Si resuelve una planta de otra empresa, se rechaza
 * y no queda rastro en esa planta.
 *
 */
export const createCommissioningEvent = (options) => (options.client ?? client).post({
    security: [
        {
            key: "appIngestionAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/app-ingestion/commissioning-events",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * Listar las NCUs declaradas de una planta
 *
 * Obtiene las NCUs del inventario declarado de una planta
 * (`configuration_declared_ncu`), con su posición para pintar el layout.
 *
 */
export const getPlantNcusDeclared = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/declared",
    ...options,
});
/**
 * Listar el placement declarado de HSU de una planta
 *
 * Obtiene las HSUs del placement declarado de una planta, con su posición para
 * pintar el layout.
 *
 */
export const getPlantDeclaredHsus = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/hsus/declared",
    ...options,
});
/**
 * Listar los dispositivos que emiten sin estar en el inventario declarado
 *
 * Cruza el inventario declarado de la configuración vigente
 * (`configuration_declared_ncu`, `configuration_declared_device`) con el catálogo
 * observado y devuelve los dispositivos que emiten sin estar declarados. Es el
 * único caso que no se puede identificar en el mapa, porque un dispositivo no
 * declarado no tiene posición asignada. El cruce es por nombre dentro de la planta
 * y no escribe nada.
 *
 */
export const getPlantDivergences = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/divergences",
    ...options,
});
/**
 * Obtener historial de disponibilidad de las últimas 24 horas
 */
export const getPlantAvailabilityHistory = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/availability-history",
    ...options,
});
/**
 * Disponibilidad acumulada de la planta en una ventana, con desglose por causa
 *
 * Calcula la disponibilidad acumulada sobre los episodios de veredicto
 * (`tcu_availability_episode`) para una ventana que termina en el momento de la
 * consulta (salvo día cerrado). El porcentaje y el desglose por causa salen del
 * mismo cálculo, así que siempre cuadran: la suma de `availability_impact_pct`
 * de las causas es `100 - availability_pct`.
 *
 */
export const getPlantAvailabilitySummary = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/availability-summary",
    ...options,
});
/**
 * Disponibilidad de la planta hora a hora en un periodo resuelto por el servidor
 *
 * Devuelve un bucket por hora (anclado a la frontera horaria UTC) desde el
 * inicio del periodo hasta su fin (`period_end`), calculado al leer sobre los
 * episodios de veredicto (`tcu_availability_episode`). Las horas sin tiempo
 * monitorizado y las futuras llevan `availability: null`; la hora que contiene
 * el ahora se calcula con lo transcurrido y lleva `is_partial: true`.
 *
 */
export const getPlantAvailabilitySeries = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/availability-series",
    ...options,
});
/**
 * Trackers afectados por una causa de indisponibilidad en un periodo resuelto por el servidor
 *
 * Desglosa el "N dispositivos afectados" de una causa en
 * `getPlantAvailabilitySummary`: un elemento por TCU, identificado por
 * `(ncu_name, tcu_name)`, con el solape de sus episodios de esa causa
 * (`tcu_availability_episode`) con el periodo. Incluye los trackers dados de
 * baja dentro del periodo. Orden descendente por `unavailable_seconds` y, a
 * igualdad, ascendente por `ncu_name` y `tcu_name`.
 *
 */
export const getPlantAvailabilityCauseDevices = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/availability-causes/{cause}/devices",
    ...options,
});
/**
 * Historial de incidencias de la planta
 *
 * Obtiene el resumen diario de incidencias de los 6 días locales previos al día en curso en la zona horaria de la planta, ordenados de más reciente a más antiguo.
 */
export const getPlantIncidencesHistory = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/incidences-history",
    ...options,
});
/**
 * Alarmas TCU por rango de fechas
 *
 * Obtiene las alarmas de los TCUs de la planta para un rango de fechas, agrupadas por tracker y TCU. Opcionalmente filtra por dispositivo.
 */
export const getPlantTcuDayAlarms = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/incidences/tcu-alarms",
    ...options,
});
/**
 * Histórico de cortes de comunicación
 *
 * Obtiene los cortes de comunicación (comm_gap) de los dispositivos de la planta que solapan con la ventana temporal indicada, ordenados por fecha de apertura descendente. Paginación keyset mediante cursor opaco.
 */
export const getPlantCommunicationGaps = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/communication-gaps",
    ...options,
});
/**
 * Alarmas HSU por rango de fechas
 *
 * Obtiene las alarmas de los HSUs de la planta para un rango de fechas. Opcionalmente filtra por dispositivo.
 */
export const getPlantHsuAlarms = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/alarms/hsu",
    ...options,
});
/**
 * Alarmas NCU por rango de fechas
 *
 * Obtiene las alarmas de las NCUs de la planta para un rango de fechas. Opcionalmente filtra por dispositivo.
 */
export const getPlantNcuAlarms = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/alarms/ncu",
    ...options,
});
/**
 * Histórico de episodios de alarma de un dispositivo
 *
 * Obtiene el histórico de episodios de alarma de un dispositivo desde la tabla alarm_episode, ordenado de más reciente a más antiguo. Consultable más allá de 7 días, con paginación keyset (cursor opaco) y ventana máxima de 92 días (el servidor la acota). A diferencia de getPlantCommunicationGaps (ventana de planta, from/to obligatorios, límite hasta 2000), este endpoint es por dispositivo: from/to son opcionales (por defecto, últimos 92 días) y el límite por página llega a 500.
 */
export const getPlantAlarmEpisodes = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/alarm-episodes",
    ...options,
});
/**
 * Alarmas activas de la planta (fuente única)
 *
 * Obtiene todas las alarmas actualmente activas de la planta desde una única lectura: los episodios de alarma abiertos (alarm_episode con ended_at null) unidos con los cortes de comunicación abiertos (comm_gap), presentando cada corte como una alarma con alarm_code 'communication'.
 */
export const getPlantActiveAlarms = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/active-alarms",
    ...options,
});
/**
 * Obtener datos de una NCU específica.
 *
 * Devuelve los datos de detalle de una NCU en una planta.
 */
export const getPlantNcuDetails = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/{ncu_name}",
    ...options,
});
/**
 * Obtener datos de detalle de un TCU específico.
 *
 * Devuelve los datos de detalle de un TCU en una planta.
 */
export const getPlantTcuDetails = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/{ncu_name}/tcus/{tcu_name}",
    ...options,
});
/**
 * Obtener datos de detalle de una HSU específico.
 *
 * Devuelve los datos de detalle de una HSU en una planta.
 */
export const getPlantHsuDetails = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/{ncu_name}/hsus/{hsu_name}",
    ...options,
});
/**
 * Configuración avanzada (comisionado) de un TCU
 *
 * Devuelve la configuración avanzada con la que quedó comisionado un TCU:
 * identidad, NCU asociada, MAC Zigbee, firmwares y versiones, fechas, offset y
 * coordenadas. Responde 200 con `commissioning_state` aunque el dispositivo aún
 * no esté comisionado (campos de comisionado en null); 404 solo si el TCU no
 * existe en el inventario declarado.
 *
 */
export const getPlantTcuCommissioning = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/{ncu_name}/tcus/{tcu_name}/commissioning",
    ...options,
});
/**
 * Configuración avanzada (comisionado) de una HSU
 *
 * Devuelve la configuración avanzada con la que quedó comisionada una HSU:
 * identidad, NCU asociada, MAC Zigbee, firmwares y versiones, fechas y
 * coordenadas. Responde 200 con `commissioning_state` aunque el dispositivo aún
 * no esté comisionado (campos de comisionado en null); 404 solo si la HSU no
 * existe en el inventario declarado.
 *
 */
export const getPlantHsuCommissioning = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/{ncu_name}/hsus/{hsu_name}/commissioning",
    ...options,
});
/**
 * Configuración avanzada (comisionado) de un TCU declarado
 *
 * Igual que `/plants/{plant_id}/ncus/{ncu_name}/tcus/{tcu_name}/commissioning`,
 * pero identifica a el TCU por su identidad declarada (`pan_id`, `slave_id`), la
 * única que existe aunque ninguna NCU declarada reclame su red. La de NCU es la
 * identidad observada, para las pantallas que parten del dispositivo que emite.
 * Responde 200 con `commissioning_state` aunque aún no esté comisionado; 404 solo
 * si no existe en el inventario declarado.
 *
 */
export const getPlantPanTcuCommissioning = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/pans/{pan_id}/tcus/{slave_id}/commissioning",
    ...options,
});
/**
 * Configuración avanzada (comisionado) de una HSU declarada
 *
 * Igual que `/plants/{plant_id}/ncus/{ncu_name}/hsus/{hsu_name}/commissioning`,
 * pero identifica a la HSU por su identidad declarada (`pan_id`, `slave_id`), la
 * única que existe aunque ninguna NCU declarada reclame su red. La de NCU es la
 * identidad observada, para las pantallas que parten del dispositivo que emite.
 * Responde 200 con `commissioning_state` aunque aún no esté comisionado; 404 solo
 * si no existe en el inventario declarado.
 *
 */
export const getPlantPanHsuCommissioning = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/pans/{pan_id}/hsus/{slave_id}/commissioning",
    ...options,
});
/**
 * Estado en tiempo real de todas las TCUs de una planta
 *
 * Devuelve un flujo en tiempo real con los datos actualizados de todas las TCUs de la planta especificada.
 */
export const getPlantTcusDataStream = (options) => (options.client ?? client).sse.get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/tcus/data",
    ...options,
});
/**
 * Search TCU telemetry data with automatic resolution selection
 *
 * Endpoint unificado para búsqueda de telemetría TCU que selecciona automáticamente
 * la resolución óptima basada en la duración del rango temporal.
 *
 * El backend decide la fuente de datos y resolución:
 * - <2h: datos raw (~6-12 segundos de resolución)
 * - 2-24h: agregación por minuto (tcu_telemetry_full)
 * - >24h: agregación por 10 minutos (tcu_telemetry_10min)
 *
 * Formato de respuesta columnar optimizado:
 * - Timestamps compartidos entre todas las series
 * - Arrays densos de valores numéricos
 * - Epoch seconds en lugar de strings ISO 8601
 * - Reducción de ~90% en tamaño de payload vs formato tradicional
 *
 * Límites de rendimiento:
 * - Máximo ~1000-1500 puntos por serie
 * - Latencia típica: <3s para cualquier rango
 * - Memoria del backend: <100MB por query
 *
 * Beneficios vs endpoints anteriores:
 * - Un solo endpoint para todos los rangos temporales
 * - El frontend no necesita decidir raw vs aggregated
 * - Respuesta optimizada para renderizado de gráficos
 *
 */
export const searchTcusTelemetry = (options) => (options.client ?? client).post({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/tcus/telemetry/search",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * Obtener predicción meteorológica para una planta
 *
 * Obtiene la predicción meteorológica para una planta específica, incluyendo datos históricos
 * del día actual y pronóstico para los próximos días.
 *
 * **Nota**: Este es un endpoint stub que devuelve datos mock para desarrollo y testing.
 * En producción, se integrará con un servicio meteorológico real.
 *
 */
export const getPlantWeather = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/weather",
    ...options,
});
/**
 * Meteo horaria guardada del proveedor de la planta en un periodo resuelto por el servidor
 *
 * Devuelve una serie por cada fuente activa (proveedor + modelo), aunque no
 * tenga filas en el periodo. Cada serie trae un bucket por hora (anclado a la
 * frontera horaria UTC) desde el inicio del periodo hasta su fin
 * (`period_end`) con las variables guardadas en `plant_weather_hourly`. Una
 * variable que el proveedor no da va a `null`; las horas sin fila y las
 * futuras, con todas las variables a `null`. La hora que contiene el ahora
 * lleva `is_partial: true` y sus variables a `null`.
 *
 */
export const getPlantWeatherHourly = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/weather/hourly",
    ...options,
});
/**
 * Estado en tiempo real de todas las HSUs de una planta
 *
 * Devuelve un flujo en tiempo real con los datos actualizados de todas las HSUs de la planta especificada.
 */
export const getPlantHsusDataStream = (options) => (options.client ?? client).sse.get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/hsus/data",
    ...options,
});
/**
 * Estado en tiempo real de NCUs de una planta
 *
 * Devuelve un flujo en tiempo real con los datos actualizados de una o varias NCUs de la planta especificada.
 */
export const getPlantNcusDataStream = (options) => (options.client ?? client).sse.get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/data",
    ...options,
});
/**
 * Obtener datos de ángulo y ángulo objetivo de seguimiento de un TCU (hoy vs ayer)
 *
 * Obtiene los datos de ángulos objetivo/reales de hoy/ayer para una TCU específica.
 */
export const getTcuTelemetryAngles = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/{ncu_name}/tcus/{tcu_name}/telemetry/angles",
    ...options,
});
/**
 * Obtener estado de carga y temperatura de la batería de una TCU (hoy vs ayer)
 *
 * Obtiene los datos de estado de carga y temperatura de batería de hoy/ayer para una TCU específica.
 */
export const getTcuTelemetryBattery1 = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/{ncu_name}/tcus/{tcu_name}/telemetry/battery_1",
    ...options,
});
/**
 * Obtener estado de voltaje y corriente de la batería de una TCU (hoy vs ayer)
 *
 * Obtiene los datos de estado de voltaje y corriente de batería de hoy/ayer para una TCU específica.
 */
export const getTcuTelemetryBattery2 = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/{ncu_name}/tcus/{tcu_name}/telemetry/battery_2",
    ...options,
});
/**
 * Obtener datos de corriente máxima y consumo del motor de una TCU (hoy vs ayer)
 *
 * Obtiene los datos de corriente máxima y consumo de hoy/ayer para el motor de una TCU específica.
 */
export const getTcuTelemetryMotor = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/{ncu_name}/tcus/{tcu_name}/telemetry/motor",
    ...options,
});
/**
 * Obtener datos de corriente y voltaje de la fuente de alimentación de una TCU (hoy vs ayer)
 *
 * Obtiene los datos de corriente y voltaje de hoy/ayer para la fuente de alimentación de una TCU específica.
 */
export const getTcuTelemetryPowerSupply = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/{ncu_name}/tcus/{tcu_name}/telemetry/power_supply",
    ...options,
});
/**
 * Snapshot agregado de viento e irradiancia de los HSUs de una planta
 *
 * Devuelve la media, mínimo y máximo de viento e irradiancia calculados
 * a partir de la última lectura de cada HSU que haya reportado dentro
 * de los últimos 15 minutos. Si ninguna HSU ha reportado en ese rango,
 * los agregados son `null`.
 *
 */
export const getPlantHsusCurrent = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/hsus/current",
    ...options,
});
/**
 * Obtener datos de telemetría de los HSUs de una planta
 *
 * Obtiene los datos históricos de telemetría para todos los HSUs de una planta específica.
 */
export const getHsusTelemetry = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/hsus/telemetry",
    ...options,
});
/**
 * Resumen horario de los sensores de la planta en un periodo resuelto por el servidor
 *
 * Devuelve un bucket por hora (anclado a la frontera horaria UTC) desde el
 * inicio del periodo hasta su fin (`period_end`) con el viento, la
 * irradiancia y la temperatura de la PCB de la planta, calculados al leer
 * sobre la media horaria de cada HSU (`hsu_telemetry_1h_avg`). Cuentan todas
 * las HSU con telemetría en esa hora, también las dadas de baja y la interna
 * de cada NCU. Una variable sin dato de ninguna HSU en una hora, o en una
 * hora futura, va a `null`; la hora que contiene el ahora lleva lo acumulado
 * hasta ese momento y `is_partial: true`.
 *
 */
export const getPlantSensorsHourly = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/sensors/hourly",
    ...options,
});
/**
 * Obtener datos de velocidad y ángulo de viento de una HSU (hoy vs ayer)
 *
 * Obtiene los datos de velocidad/ángulo de viento de hoy/ayer para una HSU específica.
 */
export const getHsuTelemetryWind = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/{ncu_name}/hsus/{hsu_name}/telemetry/wind",
    ...options,
});
/**
 * Obtener datos de altura de nieve de una HSU (hoy vs ayer)
 *
 * Obtiene los datos históricos de altura de nieve de hoy/ayer para una HSU específica.
 */
export const getHsuTelemetrySnow = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/{ncu_name}/hsus/{hsu_name}/telemetry/snow",
    ...options,
});
/**
 * Obtener voltajes de baterías y temperatura PCB de una HSU (hoy vs ayer)
 *
 * Obtiene los datos de voltajes de baterías (principal y respaldo) y temperatura del PCB de hoy/ayer para una HSU específica.
 */
export const getHsuTelemetryHardware = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/{ncu_name}/hsus/{hsu_name}/telemetry/hardware",
    ...options,
});
/**
 * Obtener datos de irradiancia de una HSU/WFU (hoy vs ayer)
 *
 * Obtiene los datos de irradiancia (GHI, GTI, DNI) de hoy/ayer para una HSU/WFU específica.
 */
export const getHsuTelemetryIrradiance = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/{ncu_name}/hsus/{hsu_name}/telemetry/irradiance",
    ...options,
});
/**
 * Archivos de log de una NCU
 *
 * Obtiene el listado de archivos de log de una NCU específica.
 */
export const getNcuLogs = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/{ncu_name}/logs",
    ...options,
});
/**
 * Archivos de log de una TCU
 *
 * Obtiene el listado de archivos de log de una TCU específico.
 */
export const getTcuLogs = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/{ncu_name}/tcus/{tcu_name}/logs",
    ...options,
});
/**
 * Archivos de log de una HSU
 *
 * Obtiene el listado de archivos de log de una HSU específica.
 */
export const getHsuLogs = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/{ncu_name}/hsus/{hsu_name}/logs",
    ...options,
});
/**
 * Detalle de un archivo de log de una NCU
 *
 * Obtiene el contenido detallado de un archivo de log específico de una NCU.
 */
export const getNcuLogDetail = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/{ncu_name}/logs/{log_name}",
    ...options,
});
/**
 * Detalle de un archivo de log de un TCU
 *
 * Obtiene el contenido detallado de un archivo de log específico de un TCU.
 */
export const getTcuLogDetail = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/{ncu_name}/tcus/{tcu_name}/logs/{log_name}",
    ...options,
});
/**
 * Detalle de un archivo de log de un HSU
 *
 * Obtiene el contenido detallado de un archivo de log específico de un HSU.
 */
export const getHsuLogDetail = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/ncus/{ncu_name}/hsus/{hsu_name}/logs/{log_name}",
    ...options,
});
/**
 * Distribución de disponibilidad de TCUs
 *
 * Stream SSE con la distribución de TCUs según su porcentaje de tiempo disponible en las últimas 24 horas (ventana deslizante). Rangos: 0-5%, 5-50%, 50-95%, 95-99%, 99-100%.
 */
export const getPlantAvailabilityDistributionStream = (options) => (options.client ?? client).sse.get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/stats/availability/stream",
    ...options,
});
/**
 * Distribución de nivel de batería de TCUs
 *
 * Stream SSE con la distribución de TCUs según su nivel de batería (SoC). Rangos: 0-20%, 20-40%, 40-60%, 60-80%, 80-100%.
 */
export const getPlantBatterySoCDistributionStream = (options) => (options.client ?? client).sse.get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/stats/battery-soc/stream",
    ...options,
});
/**
 * Distribución de ángulos de TCUs
 *
 * Stream SSE con la distribución de TCUs según su ángulo actual. Rangos fijos: -60 a -36, -36 a -12, -12 a 12, 12 a 36, 36 a 60 grados.
 */
export const getPlantAnglesDistributionStream = (options) => (options.client ?? client).sse.get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/stats/angles/stream",
    ...options,
});
/**
 * RealSky Performance para un rango de tiempo
 */
export const getPlantRealSkyPerformance = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/realsky/performance",
    ...options,
});
/**
 * Resumen Real Sky agregado sobre los últimos días cerrados
 *
 * Devuelve un resumen agregado de Real Sky sobre los últimos `days` días
 * cerrados (días completos ya transcurridos, sin incluir el día en curso) en
 * la zona horaria de la planta. El cálculo se realiza en tiempo de consulta
 * sobre los snapshots, sin tablas de agregados intermedias.
 *
 */
export const getPlantRealSkySummary = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/plants/{plant_id}/realsky/summary",
    ...options,
});
/**
 * Desactivar el aviso de disponibilidad activo
 *
 * Desactiva el aviso de disponibilidad activo del usuario de la sesión.
 *
 * Exige la feature flag `availability_alerts_enabled` activa para el usuario.
 *
 */
export const deactivateAvailabilityAlert = (options) => (options?.client ?? client).delete({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/availability-alert",
    ...options,
});
/**
 * Leer el aviso de disponibilidad activo del usuario
 *
 * Devuelve el aviso de disponibilidad activo del usuario de la sesión. Un
 * usuario tiene como mucho uno activo. Sin aviso activo, `alert` es `null`.
 *
 * Exige la feature flag `availability_alerts_enabled` activa para el usuario.
 *
 */
export const getAvailabilityAlert = (options) => (options?.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/availability-alert",
    ...options,
});
/**
 * Activar un aviso de disponibilidad
 *
 * Crea el aviso de disponibilidad activo del usuario de la sesión. Un aviso no
 * se edita: para cambiarlo se desactiva y se activa otro.
 *
 * Exige la feature flag `availability_alerts_enabled` activa para el usuario.
 *
 */
export const activateAvailabilityAlert = (options) => (options.client ?? client).post({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/availability-alert",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
/**
 * Listado de documentos técnicos disponibles
 */
export const listDocuments = (options) => (options?.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/documents",
    ...options,
});
/**
 * URL temporal de descarga para una versión de documento
 */
export const getDocumentVersionDownloadUrl = (options) => (options.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/documents/{document_id}/versions/{version}/download-url",
    ...options,
});
/**
 * Anuncios pendientes del usuario
 *
 * Devuelve los anuncios pendientes del usuario de la sesión, ordenados por
 * fecha de alta del anuncio. Un anuncio está pendiente si su flag está activa
 * para el usuario, la flag de la funcionalidad que anuncia no existe o está
 * activa para él, y no lo ha visto.
 *
 */
export const getPendingAnnouncements = (options) => (options?.client ?? client).get({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/announcements/pending",
    ...options,
});
/**
 * Marcar un anuncio como visto
 *
 * Marca el anuncio como visto para el usuario de la sesión. El primer cierre
 * gana: si ya estaba visto, responde igual y no cambia nada. No comprueba
 * flags.
 *
 */
export const markAnnouncementSeen = (options) => (options.client ?? client).put({
    security: [
        {
            key: "bearerAuth",
            scheme: "bearer",
            type: "http",
        },
    ],
    url: "/announcements/{key}/seen",
    ...options,
    headers: {
        "Content-Type": "application/json",
        ...options.headers,
    },
});
//# sourceMappingURL=sdk.gen.js.map